import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import * as BookingService from "_services/booking-service";
//
const initialState = {
  status: "idle",
  type: "Departures",
  forecastType: "Departures",
  error: null,
};

const bookingTableSlice = createSlice({
  name: "bookingTable",
  initialState,
  reducers: {
    reset: (state) => initialState,
    setTable: (state, action) => {
      return {
        ...state,
        type: action.payload,
      }
    },
    setForecastTable: (state, action) => {
      return {
        ...state,
        forecastType: action.payload,
      }
    }
  },
});

export const { reset, setTable, setForecastTable } = bookingTableSlice.actions;
export const selectBookingTableType = (state) => state.bookingTable.type;
export const selectBookingForecastTableType = (state) => state.bookingTable.forecastType;
export default bookingTableSlice.reducer;
